import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, onMounted, ref, nextTick } from 'vue'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useBreakpoint from '@/composables/useBreakpoint'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SaleBanner',
  emits: ['sale-banner-height'],
  setup(__props, { emit }) {

  

  const { sale } = useIcons()
  const { isMobileDevice } = useBreakpoint()

  const saleBannerElement = ref(null as HTMLDivElement | null)

  const saleBannerTitle = computed(() => process.env.VUE_APP_SALE_BANNER_TITLE)

  const saleBannerDescription = computed(() => process.env.VUE_APP_SALE_BANNER_DESCRIPTION)

  const bannerBackgroundColor = computed(() => {
    const envValue = process.env.VUE_APP_SALE_BANNER_BACKGROUND_COLOR_CODE
    return envValue ? `#${envValue}` : '#080d22'
  })

  const bannerColor = computed(() => {
    const envValue = process.env.VUE_APP_SALE_BANNER_FOREGROUND_COLOR_CODE
    return envValue ? `#${envValue}` : '#ffffff'
  })

  const saleTitleAndDescription = computed(() => `${saleBannerTitle.value}: <b>${saleBannerDescription.value}</b>`)

  onMounted(() => {
    nextTick(() => {
      if (saleBannerElement.value) {
        emit('sale-banner-height', saleBannerElement.value.getBoundingClientRect().height)
      }
    })
  })

  onBeforeUnmount(() => {
    emit('sale-banner-height', 0)
  })

return { __sfc: true,emit, sale, isMobileDevice, saleBannerElement, saleBannerTitle, saleBannerDescription, bannerBackgroundColor, bannerColor, saleTitleAndDescription, computed, onBeforeUnmount, onMounted, ref, nextTick, useIcons, SVGRenderer, useBreakpoint }
}

})